// Pin.jsx

// Pin.js

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { formatBoundingBox } from 'utilities/Pins';

// CSS
import './Pin.css';

// Icons
import Icon from 'svg/Icon';

/**
 * Pin
 *
 * @returns {ReactNode} The rendered component.
 */
const Pin = ({ iconKey, pinColor, pinEndColor, pin, onClick }) => {

    // ----- CONTEXT ----- //

    // Theme

    const { theme } = useTheme();
    const resolvedPinColor = pinColor ?? theme.foregroundMuted;
    const resolvedPinEndColor = pinEndColor ?? theme.foregroundMuted;

    // ----- RENDER ----- //

    return (
        <div
          className="pin-container"
          onClick={onClick}
        >

            {/* LEFT */}
            <div className="pin-left">
                <Icon
                  iconKey={iconKey}
                  color={resolvedPinColor}
                  endColor={resolvedPinEndColor}
                  width="25"
                  height="25"
                />
            </div>

            {/* RIGHT */}
            <div className="pin-right">

                {/* TITLE */}
                <div
                  className="pin-title"
                >
                    {pin.title}
                </div>

                {/* DESCRIPTION */}
                {pin.titleFull && 
                    <div
                      className="pin-description"
                    >
                        {pin.titleFull}
                    </div>
                }

                {/* DESCRIPTION */}
                {(pin.width && pin.height) && 
                    <div
                      className="pin-description"
                    >
                        {formatBoundingBox(pin.width, pin.height)}
                    </div>
                }
            </div>
        </div>
    );
};

// Dev Tools
Pin.displayName = 'Pin';

export default Pin;
